import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsReportsRoute: InvariantJiraRoute = {
	name: 'assets-reports-default-redirect',
	path: '/jira/assets/reports',
	exact: true,
};
